var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTextOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 80,
    viewBox: "0 0 225 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.727 77.6152C92.7017 73.2422 50.3758 72.0935 15.0355 53.2579C8.71173 49.8874 -1.79356 43.4624 2.91547 34.835C6.81363 27.6932 14.8956 22.7411 21.9259 19.2579C42.6896 8.97021 66.3122 4.57021 89.266 2.95594C109.853 1.50809 130.572 2.50288 151.022 5.16361C166.181 7.1361 181.438 9.88178 195.709 15.5262C204.279 18.9158 224.144 26.8304 222.897 39.1718C222.184 46.2267 214.805 51.172 209.331 54.4308C195.461 62.6872 179.449 67.8008 163.7 71.0234C138.194 76.243 111.635 75.3637 85.8814 72.4779",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextOutline);
export default __webpack_public_path__ + "static/media/text-outline.68962a8631d42e06426291a209d38655.svg";
export { ForwardRef as ReactComponent };